"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allergiesList = exports.dietaryList = exports.requiredListTypes = exports.List = exports.ListElement = exports.ListType = exports.AdditionalProperty = exports.Group = void 0;
const date_1 = require("../date/date");
class Group {
    name;
    description;
    visible;
    id;
    constructor(name, description, visible) {
        this.name = name;
        this.description = description;
        this.visible = visible;
        this.id = '';
    }
    changeName(newName) {
        this.name = newName;
    }
    changeDescription(newDescription) {
        this.description = newDescription;
    }
    changeVisibility(newVisibility) {
        this.visible = newVisibility;
    }
}
exports.Group = Group;
class AdditionalProperty {
    propertyKey;
    propertyValue;
    required;
    id;
    constructor(propertyKey, propertyValue, required) {
        this.propertyKey = propertyKey;
        this.propertyValue = propertyValue;
        this.required = required;
        this.id = '';
    }
    changeKey(newKey) {
        this.propertyKey = newKey;
    }
    changeValue(newValue) {
        this.propertyValue = newValue;
    }
}
exports.AdditionalProperty = AdditionalProperty;
class ListType {
    name;
    additionalProperties;
    id;
    constructor(name, additionalProperties) {
        this.name = name;
        this.additionalProperties = additionalProperties;
        this.id = '';
    }
    addProperty(property) {
        this.additionalProperties.push(property);
    }
    removeProperty(propertyKey) {
        this.additionalProperties = this.additionalProperties.filter((prop) => prop.propertyKey !== propertyKey);
    }
    updateAdditionalProperty(key, newValue) {
        const property = this.additionalProperties.find((prop) => prop.propertyKey === key);
        if (property) {
            property.changeValue(newValue);
        }
    }
}
exports.ListType = ListType;
class ListElement {
    name;
    description;
    additionalProperties;
    groups;
    modified_unix;
    edited_by;
    id;
    constructor(name, description, additionalProperties = [], groups = [], modified_unix = Date.now(), edited_by) {
        this.name = name;
        this.description = description;
        this.additionalProperties = additionalProperties;
        this.groups = groups;
        this.modified_unix = modified_unix;
        this.edited_by = edited_by;
        this.id = '';
    }
    // addToFavorites() {}
    // removeFromFavorites() {}
    addGroup(group) {
        this.groups.push(group);
    }
    removeGroup(groupId) {
        this.groups = this.groups.filter((group) => group.id !== groupId);
    }
    changeName(newName) {
        this.name = newName;
    }
    groupNamesAsString() {
        return this.groups.map((group) => group.name).join(', ');
    }
}
exports.ListElement = ListElement;
// On save should be implemented for each individual list use-case
class List {
    listType;
    listName;
    elements;
    onSave;
    id;
    constructor(listType, listName, elements, onSave) {
        this.listType = listType;
        this.listName = listName;
        this.elements = elements;
        this.onSave = onSave;
        this.id = '';
    }
    addElements(elements) {
        this.elements.push(...elements);
    }
    removeElement(elementId) {
        this.elements = this.elements.filter((element) => element.id !== elementId);
    }
    changeName(newName) {
        this.listName = newName;
    }
    changeDescription(newDescription) {
        this.listName = newDescription;
    }
    moveElement(fromIndex, toIndex) {
        this.elements.splice(toIndex, 0, this.elements.splice(fromIndex, 1)[0]);
    }
}
exports.List = List;
// Lists
exports.requiredListTypes = {
    DIETARY: 'dietary_requirements',
    ALLERGIES: 'allergies_requirements',
};
// Dietary List
const nowDateMS = new date_1.EventrDate().getUnixMs;
const dietaryListType = new ListType(exports.requiredListTypes.DIETARY, []);
const glutenIntolerance = new ListElement('Gluten Intolerance', '', [], [], nowDateMS, '');
const vegetarian = new ListElement('Vegetarian', '', [], [], nowDateMS, '');
const pescatarian = new ListElement('Pescatarian', '', [], [], nowDateMS, '');
const halal = new ListElement('Halal', '', [], [], nowDateMS, '');
const kosher = new ListElement('Kosher', '', [], [], nowDateMS, '');
exports.dietaryList = new List(dietaryListType, 'Dietary List', [glutenIntolerance, vegetarian, pescatarian, halal, kosher], () => {
    // empty
});
// Allergies List
const allergiesListType = new ListType(exports.requiredListTypes.ALLERGIES, []);
const nuts = new ListElement('Nuts', '', [], [], nowDateMS, '');
const seafoodCrustaceans = new ListElement('Seafood Crustaceans', '', [], [], nowDateMS, '');
const eggs = new ListElement('Eggs', '', [], [], nowDateMS, '');
const dairy = new ListElement('Dairy', '', [], [], nowDateMS, '');
const soya = new ListElement('Soya', '', [], [], nowDateMS, '');
const sulphites = new ListElement('Sulphites', '', [], [], nowDateMS, '');
const fruit = new ListElement('Fruits', '', [], [], nowDateMS, '');
const vegetables = new ListElement('Vegetables', '', [], [], nowDateMS, '');
// Create the List for allergies using the defined type and elements
exports.allergiesList = new List(allergiesListType, 'Allergies List', [nuts, seafoodCrustaceans, eggs, dairy, soya, sulphites, fruit, vegetables], () => {
    // empty
});
